import { resolveCountry, LOCALE_BY_COUNTRY } from "./FormatByCountry";

const formatCompactNumber = (val: number | string) => {
  const raw = Number(val || 0);
  const n = Number.isFinite(raw) ? raw : 0;
  const abs = Math.abs(n);
  const country = resolveCountry();
  const locale = LOCALE_BY_COUNTRY[country];
  const isMy = country === "MY";
  const join = (formatted: string, suffix: string) =>
    isMy ? `${formatted}${suffix}` : `${formatted} ${suffix}`;

  if (abs >= 1_000_000_000) {
    const v = n / 1_000_000_000;
    const formatted = v.toLocaleString(locale, {
      maximumFractionDigits: 1,
      minimumFractionDigits: 0,
    });
    return join(formatted, isMy ? "b" : "m");
  }
  if (abs >= 1000000) {
    const v = n / 1000000;
    const formatted = v.toLocaleString(locale, {
      maximumFractionDigits: 1,
      minimumFractionDigits: 0
    });
    return join(formatted, isMy ? "m" : "jt");
  }
  if (abs >= 1000) {
    const v = n / 1000;
    const formatted = v.toLocaleString(locale, {
      maximumFractionDigits: 1,
      minimumFractionDigits: 0
    });
    return join(formatted, isMy ? "k" : "rb");
  }
  return n.toLocaleString(locale);
};

export default formatCompactNumber;
